/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_ImportInputs */

const en_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Import`)
};

const fr_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l’import`)
};

const de_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen Import`)
};

const it_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci importazione`)
};

const ru_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние Импорт`)
};

const es_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar importación`)
};

const zh_cn2_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并导入`)
};

const ja_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージインポート`)
};

const hi_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मर्ज आयात`)
};

const pt_pt2_merge_import = /** @type {(inputs: Merge_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar Importação`)
};

/**
* | output |
* | --- |
* | "Merge Import" |
*
* @param {Merge_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_import = /** @type {((inputs?: Merge_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_import(inputs)
	if (locale === "de") return de_merge_import(inputs)
	if (locale === "it") return it_merge_import(inputs)
	if (locale === "ru") return ru_merge_import(inputs)
	if (locale === "es") return es_merge_import(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_import(inputs)
	if (locale === "ja") return ja_merge_import(inputs)
	if (locale === "hi") return hi_merge_import(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_import(inputs)
	return en_merge_import(inputs)
});